import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { CameraScannerComponent } from '../../components/camera-scanner/camera-scanner.component';

@Component({
  selector: 'app-camera-demo',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    CardModule,
    TagModule,
    ToastModule,
    CameraScannerComponent,
  ],
  templateUrl: './camera-demo.component.html',
})
export class CameraDemoComponent {
  showScanner = false;

  constructor(private messageService: MessageService) {}

  toggleScanner(): void {
    this.showScanner = !this.showScanner;
  }

  showApiInfo(): void {
    this.messageService.add({
      severity: 'info',
      summary: 'API Information',
      detail: 'This scanner integrates with Laava API for advanced QR code scanning capabilities. Visit the developer portal to get your API key.',
      life: 5000
    });
  }
} 